/* eslint-disable no-nested-ternary */
/* eslint-disable no-debugger */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { UserActions } from '../../redux/actions/user.action';
import CustomToast from '../AlertPopup';
import Footer from '../Footer';
import Header from '../Header';
import LoginScreen from './LoginScreen';
import OtpScreen from './OtpScreen';

function Login({ login, VerifyOtp, resendOtp }) {
    useEffect(() => {
        localStorage.removeItem('success-popup');
        document.body.style.overflow = 'hidden';
    }, []);

    const [Email, setEmail] = useState('');
    const [password, setpassword] = useState('');
    const [iniitialAuthentication, setiniitialAuthentication] = useState(false);
    const [isError, setisError] = useState(false);
    const [session, setsession] = useState('');
    const [loading, setloading] = useState(false);
    const [open, setopen] = useState(false);
    const [loginError, setLoginError] = useState(false);
    const [otp, setotp] = useState({
        one: '',
        two: '',
        three: '',
        four: '',
        five: '',
        six: '',
    });
    const [otpError, setotpError] = useState(false);
    /**
 *
 * @param {*} elmnt ;
 * For focusing on each input field.
 */
    const inputfocus = (elmnt) => {
        if (elmnt.key === 'Delete' || elmnt.key === 'Backspace') {
            const next = elmnt.target.tabIndex - 2;
            if (next > -1) {
                elmnt.target.form.elements[next].focus();
            }
        } else {
            const next = elmnt.target.tabIndex;
            if (next < 6) {
                elmnt.target.form.elements[next].focus();
            }
        }
    };

    /**
     * @param {e} e ;
     * validate whether all required fields are filled
     */
    const ValidateUserInput = (e) => {
        e.preventDefault();
        setloading(true);
        setLoginError(false);
        if (Email && password) {
            login(Email, password).then((val) => {
                if (!val.error && val.data.success_status) {
                    setsession(val.data.data.session);
                    setLoginError(val?.data?.data?.otp_failure);
                    setloading(false);
                    setopen(true);
                    localStorage.setItem('success-popup', 1);
                    setTimeout(() => {
                        setopen(false);
                    }, 4000);
                    setiniitialAuthentication(true);
                } else {
                    setisError(val?.message?.response?.data?.message);
                    setloading(false);
                }
            });
        } else {
            setisError(true);
            setloading(false);
        }
    };

    /**
     *
     * @param {*} email ;
     * resend otp handler
     */
    const resendOtphandler = (email) => {
        setLoginError(false);
        if (Email) {
            resendOtp(email, session).then((val) => {
                if (!val.error) {
                    setopen(true);
                    setLoginError(val?.data?.data?.otp_failure);
                    setTimeout(() => {
                        setopen(false);
                        // localStorage.setItem('user', JSON.stringify(val.data.data));
                    }, 4000);
                    setiniitialAuthentication(true);
                    setsession(val.data.data.session);
                } else {
                    setisError(true);
                }
            });
        } else {
            setisError(true);
        }
    };
    /**
 *
 * @returns all input fields are fill
 */
    const otpValidation = () => {
        let isvalid = true;
        Object.keys(otp).some((val) => {
            if (otp[val] === '') {
                isvalid = false;
            }
        });
        return isvalid;
    };
    /**
 * @param {} Event value ;*
 *It will construct OTP and return while submitting
 */

    const contructOtp = () => {
        let init = '';
        Object.keys(otp).map((val) => {
            init += otp[val];
        });
        return init;
    };

    /**
 * @param {e} Event value ;*
 *Otp validation returns true or false
 *Verify OTP Api call
 */
    const handleOtp = (e) => {
        e.preventDefault();
        setloading(true);
        if (otpValidation() === false) {
            setotpError(true);
            setloading(false);
        } else {
            VerifyOtp(Email, contructOtp(), session).then((val) => {
                if (!val.error) {
                    localStorage.setItem('login_time', moment());
                    setloading(false);
                } else {
                    setotpError(true);
                    setloading(false);
                }
            });
        }
    };
    function OtpSendMeessage() {
        return (
            <p className=" text-[#090406] font-medium pl-[54px] py-3" style={{ fontSize: '15px', color: '#808285' }}>
                New OTP has been sent to the
                <br />
                {' '}
                registered email address and mobile number
            </p>
        );
    }
    function ToastError() {
        return (
            <p className=" text-[#090406] font-medium pl-[54px] py-3" style={{ fontSize: '15px', color: '#808285' }}>
                New OTP has been sent to the
                <br />
                {' '}
                {`registered ${loginError.toLowerCase() === 'mobile number' ? 'email address' : 'mobile number'}`}
            </p>
        );
    }

    function OtpSuccessMeessage() {
        return (
            <p className=" text-[#090406] font-medium pl-[54px] py-3" style={{ fontSize: '15px', color: '#808285' }}>
                Otp Verification Successful!
                <br />
            </p>
        );
    }
    return (
        <div style={{ overflow: 'hidden' }}>
            <Header />
            {!iniitialAuthentication ? (
                <LoginScreen
                    Email={Email}
                    password={password}
                    setEmail={setEmail}
                    setpassword={setpassword}
                    ValidateUserInput={ValidateUserInput}
                    isError={isError}
                    setisError={setisError}
                    loading={loading}
                />
            ) : (
                <OtpScreen
                    Email={Email}
                    otpError={otpError}
                    setotpError={setotpError}
                    setotp={setotp}
                    handleOtp={handleOtp}
                    inputfocus={inputfocus}
                    otp={otp}
                    resendOtp={resendOtphandler}
                    loading={loading}
                    iniitialAuthentication={iniitialAuthentication}
                    setiniitialAuthentication={setiniitialAuthentication}
                    loginError={loginError}

                />
            )}
            {open && (
                <CustomToast
                    open={open}
                    setopen={setopen}
                    message={!iniitialAuthentication
                        ? <OtpSuccessMeessage />
                        : !loginError ? <OtpSendMeessage /> : <ToastError />}
                />
            )}
            <Footer />
        </div>
    );
}
function mapState(state) {
    const { loggedIn } = state.authentication;
    const { alert } = state;
    return { loggedIn, alert };
}
const actionCreator = {
    // loginFunction: UserActions.login,
    login: UserActions.login,
    VerifyOtp: UserActions.VerifyOtp,
    resendOtp: UserActions.resendOtp,

};
const connectedLoginPage = connect(mapState, actionCreator)(Login);
export { connectedLoginPage as Login };
